import { Route, Routes } from 'react-router-dom';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Page404 } from 'framework/statusPages';
import { ProtectedRouter } from 'infrastructure/routing';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { TASK_CONSTRUCTOR_LIST_READ, TASK_CONSTRUCTOR_PATH } from './constants';
import { useTaskConstructorRoute } from './routing';
import TaskConstructorListPage from './List';
import CreateTaskConstructorLayout from './createUpdate/CreateTaskConstructorLayout';

const TaskConstructorRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, singleEntityRoute, createRoute } = useTaskConstructorRoute();

  return (
    <ProtectedRouter basePath={TASK_CONSTRUCTOR_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            //TODO: update permission
            <GlobalProtectedRoute globalPermissionToCheck={TASK_CONSTRUCTOR_LIST_READ}>
              <TaskConstructorListPage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={createRoute}
          element={
            //TODO: update permission
            <GlobalProtectedRoute globalPermissionToCheck={TASK_CONSTRUCTOR_LIST_READ}>
              <CreateTaskConstructorLayout />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={TASK_CONSTRUCTOR_LIST_READ}>
              <></>
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

TaskConstructorRouter.getRouterPath = () => `/task-constructor/*`;

export default TaskConstructorRouter;
